module.exports = __webpack_public_path__ + "img/co-branding-world-JET-background-3.690315b9.png";